export default __webpack_public_path__ + "static/media/fireFN23.930145ed.svg";